import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 11H4v-1h11v1zM9.5 2C4.813 2 1 5.813 1 10.5S4.813 19 9.5 19s8.5-3.813 8.5-8.5S14.187 2 9.5 2zm0-1c5.225 0 9.5 4.275 9.5 9.5S14.725 20 9.5 20 0 15.725 0 10.5 4.275 1 9.5 1z',
  ],
  height: 20,
  width: 20,
});
